import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Modules
import { UiModule } from 'src/app/platform/ui.module';
import { MaterialModule } from 'src/app/platform/material.module';

// Services
import { UserService } from 'src/app/modules/account/user.service';

// Components
import { AccountsMessagesComponent } from 'src/app/modules/account/components/accounts-messages/accounts-messages.component';
import { AccountsAdminSelectComponent } from 'src/app/modules/account/components/accounts-admin-select/accounts-admin-select.component';
import { AccountsBiometricAddComponent } from 'src/app/modules/account/components/accounts-biometric-add/accounts-biometric-add.component';

@NgModule({
  declarations: [
    AccountsMessagesComponent,
    AccountsAdminSelectComponent,
    AccountsBiometricAddComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    UiModule,
  ],
  exports:[
    AccountsMessagesComponent,
    AccountsAdminSelectComponent,
    AccountsBiometricAddComponent
  ],
  providers: [
    UserService
  ]
})
export class UserModule { }
